import type { ReactNode } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'
import { FwIcon } from '@fourthwall/icons'
import { Heading } from '../Heading'
import { Icon } from '../Icon'
import { Loader } from '../Loader'
import * as S from './styled'

type Props = {
  to?: string
  heading: string
  description: string
  actions?: ReactNode
  loader?: boolean
  maxWidth?: number
}

export const ErrorPage = ({ to, heading, description, actions, loader, maxWidth }: Props) => {
  return (
    <S.Container>
      {to && (
        <S.LogoContainer as={Link} to={to}>
          <Icon component={FwIcon} height={28} />
        </S.LogoContainer>
      )}
      {!to && (
        <S.LogoContainer>
          <Icon component={FwIcon} height={28} />
        </S.LogoContainer>
      )}
      <S.Main $maxWidth={maxWidth}>
        {loader && (
          <S.LoaderContainer>
            <Loader size="large" />
          </S.LoaderContainer>
        )}
        <Heading type="h2" weight="bold">
          {heading}
        </Heading>
        {description && <S.Description>{description}</S.Description>}
        {actions && <S.ActionsContainer>{actions}</S.ActionsContainer>}
      </S.Main>
    </S.Container>
  )
}
